import { useState, useEffect, useRef } from "react";
const showrooms = [{
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1653984/img/LS_Showroom-thumbnail-Birmingham_1125x1500.jpg",
  label: "BIRMINGHAM",
  accent: "#C9B99A"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1653984/img/LS_Showroom-thumbnail-Hampshire_1125x1500.webp",
  label: "HAMPSHIRE",
  accent: "#B5AFA8"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1653984/img/LS_Showroom-thumbnail-Manchester_1125x1500.webp",
  label: "MANCHESTER",
  accent: "#A9B2BC"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1653984/img/LS_Home_Showroom-show-all-1.webp",
  label: "SHOW ALL",
  accent: "#2C2C2C"
}];
export default function ShowroomLocationTiles() {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);
  const [visible, setVisible] = useState(false);
  const sectionRef = useRef<HTMLElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setVisible(true);
      }
    }, {
      threshold: 0.15
    });
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);
  return;
}